const PROD_API_HOSTS: Record<string, string> = {
  'beta.simulador.proteautobrasil.com.br': 'api.beta.simulador.proteautobrasil.com.br',
};

const DEFAULT_PROD_API_HOST = 'api.simulador.proteautobrasil.com.br';
const DEV_API_URL = 'https://proteauto-simulador-v3.test/v1';

function resolveApiBaseUrl(): string {
  if (process.env.NODE_ENV !== 'production') {
    return DEV_API_URL;
  }

  const host = PROD_API_HOSTS[window.location.hostname] ?? DEFAULT_PROD_API_HOST;
  return `https://${host}/v1`;
}

export default resolveApiBaseUrl();
